export default __webpack_public_path__ + "static/formular-risikobeurteilung-das-ohr-170f92e1371f7308bc3676a57c5dd7ee.pdf";